export default __webpack_public_path__ + "static/1-76b9fecc7715e05ef30c0ddb7fcdb7b6.jpeg";